export const ANALYSIS_VERSION = 0;
